/* global $, site_url */

// PRODUCT IMAGE SLIDESHOW
$('.single-product-gallery').slick({
  arrows: false,
  dots: true,
  adaptiveHeight: true
});

// WISHLIST
// Add/remove products from the product page
$(".wishlist-toggle").on("click",function(e){
  e.preventDefault();
  var prod_id = $(this).data("prod-id");
  var wishlist_icon = $(this).find(".wishlist-icon");
  var wishlist_text = $(this).find(".wishlist-text");
  if(wishlist_icon.hasClass("in-wishlist")) {
    //Remove it
    $.ajax({
      url:  site_url+'site/ajax/shop-wishlist-remove.php',
      type: 'post',                
      data: {
        prodID: prod_id 
      },
      dataType: "json"
    })
    .done(function(data) {
      if($.isNumeric(data)) {
        wishlist_icon.removeClass("in-wishlist");
        wishlist_text.text("Add to favourites");
      }
      else if(data !== '') {
        alert(data);
      }
    });
    // Change icon
    wishlist_icon.removeClass('icon-heart');
    wishlist_icon.addClass('icon-heart-o');
  }
  else
  {
    //Add it
    $.ajax({
      url:  site_url+'site/ajax/shop-wishlist-add.php',
      type: 'post',                
      data: {
        prodID: prod_id 
      },
      dataType: "json"
    })
    .done(function( data ) {
      if($.isNumeric(data)) {
        wishlist_icon.addClass("in-wishlist");
        wishlist_text.text("Remove from favourites");
      }
      else if(data!=='') {
        alert(data);
      }
    });
    // Change icon
    wishlist_icon.removeClass('icon-heart-o');
    wishlist_icon.addClass('icon-heart');
  }
});

// Remove products from the wishlist grid
$(".product-thumbnail .wishlist-remove").on("click",function(e){
  e.preventDefault();
  var prod_id = $(this).data("prod-id");
  var product_thumbnail = $(this).closest(".product-thumbnail");

  $.ajax({
    url:  site_url+'site/ajax/shop-wishlist-remove.php',
    type: 'post',                
    data: {
      prodID: prod_id 
    },
    dataType: "json"
  })
  .done(function(data) {
    if($.isNumeric(data)) {
      product_thumbnail.fadeOut(1000,function(){
        if(data < 1) {
          $(".wishlist-empty").addClass("show");
        }
      });
    }
    else if(data !== '') {
      alert(data);
    }
  });
  
});